import { PERSONALIZATION_API as API } from "../../config/apiConfig";

export const getViews = (params = {}) => {
  return API({
    url: "/personalization/user",
    method: "GET",
    params: params,
  });
};

export const getPersonalizedTaxonomy = (params = {}) => {
  return API({
    url: "/personalization/taxonomy-master",
    method: "GET",
    params: params,
  });
};